<div
  class="input-control"
  style="height: 40px"
  [ngClass]="{ invalid: !isValid }"
>
  <div [innerHTML]="prependHtml" *ngIf="prependHtml"></div>
  <span *ngIf="prepend" (click)="onPrependClick($event)">
    <!-- fa fa-search -->
    <i [ngClass]="prepend"></i>
  </span>
 <input
    class="form-control"
    [type]="_type"
    [placeholder]="placeholder"
    [value]="value"
    [disabled]="disabled"
    [style.background]="background"
    [ngClass]="{ 'input-error': showInvalid }"
    (input)="onInputChange($event)"
    (blur)="onBlur()"
    (keydown)="onKeyDown($event)"
  />

  <span *ngIf="append" (click)="onAppendClick($event)">
    <!-- fa fa-search -->
    <i [ngClass]="append"></i>
  </span>

  <div [innerHTML]="appendHtml" *ngIf="appendHtml"></div>
</div>
